export default __webpack_public_path__ + "static/media/pin.bb4dccb5.svg";